module.exports = __webpack_public_path__ + "img/excellent.1350ddf6.png";